namespace Areas.Vendor.Contact {
    "use strict";

    let currentContact: any;
    let contactDisplayName: string;
    let primaryVendorId: number;
    let primaryVendorName: string;


    export function newVendorContact(e) {

        let dataGrid = $('#ContactGrid').dxDataGrid('instance');
        let vendorId = dataGrid.option('VendorId');

        currentContact = e.data;
        currentContact.isActive = true;
        currentContact.isAdmin = false;
        currentContact.isInsuranceContact = false;
        currentContact.vendorId = vendorId;
    }

    export function selectContact() {
        const contactDialog = new Areas.Dialogs.ContactDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#ContactGrid").dxDataGrid("instance");

        var rowIndex = getRowIndex(dataGrid);
        updateGridRow(dataGrid, rowIndex, data);
    }

    function getRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentContact === undefined || currentContact === null) {
            return rowIndex;
        } else if (currentContact.vendorContactId) {
            rowIndex = dataGrid.getRowIndexByKey(currentContact.vendorContactId);
        }

        return rowIndex;
    }

    function updateGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "contactId", data.contactId);
        dataGrid.cellValue(rowIndex, "displayName", data.displayName);
        dataGrid.cellValue(rowIndex, "primaryEMail", data.primaryEMail);
        dataGrid.cellValue(rowIndex, "workPhone", data.workPhone);

        contactDisplayName = data.displayName;

        currentContact.contactId = data.contactId;
        currentContact.displayName = data.displayName;
        currentContact.primaryEMail = data.primaryEMail;
        currentContact.workPhone = data.workPhone;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onNewRowInserted(e: any) {
        currentContact = null
    }

    export function onEditingStart(e: any) {
        currentContact = e.data;
    }

    export function onNewContactInsert(e: any) {
        currentContact = null
    }

    export function onContactEditingStart(e: any) {
        currentContact = e.data;
    }


    export function editContactTemplate(cellElement, cellInfo) {
        let displayName = !contactDisplayName ? "Select..." : contactDisplayName;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${displayName}</div><div class="dx-lookup-arrow" id="vendor-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectContact);
        cellElement.append(html);
    }


}